import { withFormik, Field, Form, getIn } from 'formik';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import { FormikSelect } from '../../../../components';
import { multiTimeTypes } from '../../../../components/Attendance/formOptions';

const MassiveAttendanceActionsForm = ({ isSubmitting, isDisabled, errors, setFieldValue, touched, ...props }) => {
  const { onHide } = props;

  const ALL_SELECTED_LABEL = 'all';

  const hasAllSelection = (groupSelection = []) => {
    return groupSelection.some(option => option.value === ALL_SELECTED_LABEL);
  };

  const handleDisabledSelection = (options, selectedOptions) => {
    if (hasAllSelection(selectedOptions)) {
      return true;
    }
    if (selectedOptions.length === 0) return false;
    return options.value === ALL_SELECTED_LABEL;
  };

  const handleNewMulti = (data, field, allowEmpty = false) => {
    const newData = data.map(element => element.value);
    if (newData.length && newData.includes(ALL_SELECTED_LABEL)) {
      newData.push('');
      return;
    }

    if (allowEmpty && !newData.length) newData.push('');
    setFieldValue(field, newData);
  };

  return (
    <Form className="mx-3">
      <Row>
        <Col md={12}>
          <Field name="attendance[timeType]">
            {({ field }) => (
              <FormikSelect
                {...field}
                abbr
                isMulti
                label="Tipo de Maración"
                placeholder="Seleccionar Tipo de Marcación"
                options={multiTimeTypes}
                onChange={data => {
                  handleNewMulti(data || [], field.name, true);
                  setFieldValue(field.name, data || []);
                }}
                isOptionDisabled={handleDisabledSelection}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row className="d-flex justify-content-end mt-3 mb-2">
        <Col xs={6} sm={4}>
          <Button block type="submit" variant="primary" onClick={onHide} disabled={isSubmitting || isDisabled}>
            Aceptar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const setInitialValues = props => {
  const { status } = props;
  return {
    attendance: {
      timeType: [],
      status
    }
  };
};

const validationSchema = Yup.object().shape({
  attendance: Yup.object().shape({
    timeType: Yup.array().min(1, 'Debes escoger al menos un tipo de marcación.')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(MassiveAttendanceActionsForm);
